import React, { useState } from 'react';
import SectionEdition, { Slot } from 'components/styleguide/section_edition/SectionEdition';
import Sheet from 'components/styleguide/sheet_modal/Sheet';
import SearchInput, { Item } from 'components/styleguide/search_input/SearchInput';
import { useEditableSheet } from 'components/styleguide/sheet_modal/useEditableSheet';
const styles = require('../onboarding-cards.module.scss');

interface LanguagesSectionProps {
  languages: Item[];
  languagesList: Item[];
  url: string;
  required?: boolean;
}

const LanguagesSection: React.FC<LanguagesSectionProps> = ({ languages: initialLanguages, languagesList, url, required = false }) => {
  const [languages, setLanguages] = useState<Item[]>(initialLanguages || []);
  const [pendingLanguages, setPendingLanguages] = useState<Item[]>([]);

  const sheet = useEditableSheet({
    url: url,
    payloadKey: 'talent',
    onSuccess: () => {
      setLanguages(pendingLanguages);
    },
  });

  const hasAny = languages.length > 0;
  const status = hasAny ? 'complete' : required ? 'mandatory' : 'missing';

  const handleAddClick = () => {
    sheet.open('Add languages', {});
  };

  const handleEditClick = () => {
    setPendingLanguages(languages);
    sheet.open('Edit languages', {
      language_proficiency_ids: languages.map(l => l.value),
    });
  };

  const handleLanguagesChange = (updated: Item[]) => {
    setPendingLanguages(updated);
    sheet.handleFormChange('language_proficiency_ids', updated.map(l => l.value));
  };

  return (
    <>
      <SectionEdition
        title="Languages"
        iconName="globe"
        context="talent"
        status={status}
        onEdit={handleEditClick}
        onAdd={hasAny ? undefined : handleAddClick}
      >
        {hasAny && (
          <Slot>
            <p className={styles.value}>
              {languages.map(l => l.label).join(', ')}
            </p>
          </Slot>
        )}
      </SectionEdition>

      {sheet.isOpen && (
        <Sheet
          title={sheet.sheetTitle}
          onClose={sheet.close}
          context="talent"
          showCancelButton={false}
          continueButtonText="Save"
          onContinue={sheet.handleSave}
        >
          <SearchInput
            initialItems={languages}
            options={languagesList}
            label="Languages"
            placeholder="e.g. English"
            required={true}
            error={sheet.getError('language_proficiency_ids')}
            onChange={handleLanguagesChange}
            context="talent"
          />
        </Sheet>
      )}
    </>
  );
};

export default LanguagesSection;
